// extracted by mini-css-extract-plugin
module.exports = {"emptyTable":"EmptyTable_emptyTable__1pvyN","emptyTableText":"EmptyTable_emptyTableText__2YP7O"};